<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="card-brutal group block p-5 h-full"
  >
    <div class="flex items-start justify-between gap-3 mb-4">
      <div
        class="inline-flex items-center justify-center w-10 h-10 border-2 border-border rounded-md"
        :class="iconBgClass"
      >
        <!-- Chat -->
        <svg
          v-if="icon === 'chat'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z" />
        </svg>

        <!-- Run -->
        <svg
          v-else-if="icon === 'run'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polygon points="5 3 19 12 5 21 5 3" />
        </svg>

        <!-- VIP -->
        <svg
          v-else-if="icon === 'vip'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>

        <!-- Pool -->
        <svg
          v-else-if="icon === 'pool'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8" />
          <path d="M12 17v4" />
          <path d="M6 8h.01" />
          <path d="M10 8h.01" />
          <path d="M14 8h.01" />
          <path d="M18 8h.01" />
        </svg>

        <!-- School -->
        <svg
          v-else-if="icon === 'school'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M22 10l-10-6-10 6 10 6 10-6z" />
          <path d="M6 12v5a6 3 0 0 0 12 0v-5" />
        </svg>

        <!-- Cloud -->
        <svg
          v-else-if="icon === 'cloud'"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        </svg>
      </div>
      <svg
        class="w-4 h-4 text-text-secondary transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path d="M7 5h8v8" />
        <path d="M17 5L5 17" />
      </svg>
    </div>

    <div class="flex items-baseline justify-between gap-2 mb-1.5">
      <h3 class="text-lg font-bold">{{ title }}</h3>
      <span v-if="subtitle" class="text-xs font-medium text-text-secondary shrink-0">{{ subtitle }}</span>
    </div>
    <p class="text-text-secondary text-sm leading-relaxed mb-4 line-clamp-2">{{ description }}</p>

    <div class="flex flex-wrap gap-1.5">
      <span
        v-for="tag in tags"
        :key="tag"
        class="badge-brutal text-xs"
        :class="tagBgClass"
      >
        {{ tag }}
      </span>
    </div>
  </a>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  href: {
    type: String,
    required: true,
  },
  tags: {
    type: Array,
    default: () => [],
  },
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'lavender', 'red'].includes(value),
  },
  icon: {
    type: String,
    default: 'chat',
    validator: (value) => ['chat', 'run', 'vip', 'pool', 'school', 'cloud'].includes(value),
  },
});

const iconBgClass = computed(() => {
  const map = {
    primary: 'bg-primary',
    lavender: 'bg-brutal-lavender',
    red: 'bg-brutal-red',
  };
  return map[props.variant];
});

const tagBgClass = computed(() => {
  const map = {
    primary: 'bg-primary-light',
    lavender: 'bg-brutal-lavender/40',
    red: 'bg-brutal-red/30',
  };
  return map[props.variant];
});
</script>
